import React from 'react';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import Confirm from 'components/Confirm';
import messages from 'features/App/App.messages';
import { freeClassMessages } from './ClassDetail.messages';
import './ClassDetail.scss';

const { element } = bem('class-detail');

const EnableFreeClassModal = () => (
  <Confirm
    className="confirm--danger"
    size="medium"
    title={<Message message={freeClassMessages.confirmationTitle} />}
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={freeClassMessages.yes} />}
    isOpen>
    <Message
      message={freeClassMessages.confirmationSubtitle}
      values={{
        irreversibleExplainer: (
          <Message className={element('free-class-danger')} message={freeClassMessages.irreversibleExplainer} />
        ),
      }}
    />
  </Confirm>
);

export default EnableFreeClassModal;
